import { view, cssGenerator } from '@yola/ws-sdk';
import { BREAKPOINT_READ_CASCADE, DESKTOP_BREAKPOINT } from '../constants/breakpoints';

const { POSITION: POSITION_CLASS } = cssGenerator.constants.classNames;

const parsePositionValue = (value) => {
  const [x, y] = value
    .trim()
    .split(/[_\s]+/)
    .map((part) => parseFloat(part));

  return { x, y };
};

const getCompositeItemPosition = ({ element, breakpoint = null }) => {
  const cascade = BREAKPOINT_READ_CASCADE[breakpoint] || [DESKTOP_BREAKPOINT];

  for (let i = 0; i < cascade.length; i += 1) {
    const value = view.accessors.getResponsiveClassValue({
      element,
      className: POSITION_CLASS,
      breakpoint: cascade[i],
    })?.value;

    if (value) return parsePositionValue(value);
  }

  return { x: 50, y: 50 };
};

export default getCompositeItemPosition;
